import React, { forwardRef } from "react";
import { Item } from './styles';
export var OptionItem = forwardRef(function (_ref, ref) {
  var align = _ref.align,
      children = _ref.children,
      _ref$dividerColor = _ref.dividerColor,
      dividerColor = _ref$dividerColor === void 0 ? 'light' : _ref$dividerColor,
      handleClick = _ref.handleClick,
      hasBorderRadius = _ref.hasBorderRadius,
      hasDivider = _ref.hasDivider,
      hasFirstDivider = _ref.hasFirstDivider,
      _ref$size = _ref.size,
      size = _ref$size === void 0 ? 'regular' : _ref$size;
  return React.createElement(Item, {
    ref: ref,
    align: align,
    dividerColor: dividerColor,
    hasBorderRadius: hasBorderRadius,
    hasDivider: hasDivider,
    hasFirstDivider: hasFirstDivider,
    onClick: handleClick,
    size: size
  }, children);
});